// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1exUE","newExpiryDate":"styles_newExpiryDate__4xnHq","footer":"styles_footer__2fclu"};